import { useContext } from 'react'
import { AppContext, AppContextType } from '../../AppContext'
import PerfStatsPage from './PerfStatsPage'
import CrossPlatformDialog from '@/dialogs/components/CrossPlatformDialog'

export default function AudioEngineDevSettingsPageController() {
    const { state: appState, dispatch: appDispatch } = useContext(AppContext) as AppContextType

    if (appState.appState.showPerfStatsPage) {
        return (
            <CrossPlatformDialog
                frameName="Dialog:PerfStatsPage"
                onDefaultClose={() => {
                    appDispatch({ type: 'update_app_state', value: { showPerfStatsPage: false } })
                }}
            >
                <PerfStatsPage />
            </CrossPlatformDialog>
        )
    } else {
        return null
    }
}
